import type { GarageMemberResponse, MemberNotificationSettings } from '../../types/settings';

const ALL_ON: MemberNotificationSettings = { enabled: true, whatsapp: true, email: true };

/** Spec 076 — the stored settings, defaulting to all on for a response without them. */
export function memberNotifications(member: GarageMemberResponse): MemberNotificationSettings {
  return member.notifications ?? ALL_ON;
}

/**
 * Spec 076 — what a member actually receives: "Off" when the master switch is off (or no channel
 * would deliver), otherwise one badge per channel that is checked AND deliverable, plus a muted
 * hint for a checked channel the member's contact cannot receive. Text, not colour, carries the state.
 */
export default function MemberNotificationBadges({ member, t }: {
  member: GarageMemberResponse;
  t: (key: string) => string;
}) {
  const n = memberNotifications(member);
  const whatsappOk = member.whatsappDeliverable !== false;
  const emailOk = member.emailDeliverable !== false;
  const whatsapp = n.enabled && n.whatsapp && whatsappOk;
  const email = n.enabled && n.email && emailOk;
  const noPhone = n.enabled && n.whatsapp && !whatsappOk;
  const noEmail = n.enabled && n.email && !emailOk;

  return (
    <span className="member-notify-badges" data-testid={`member-notify-${member.id}`}>
      {whatsapp && <span className="member-notify-badge">{t('settings.memberNotifications.whatsapp')}</span>}
      {email && <span className="member-notify-badge">{t('settings.memberNotifications.email')}</span>}
      {!whatsapp && !email && (
        <span className="member-notify-badge member-notify-badge-off">{t('settings.memberNotifications.off')}</span>
      )}
      {noPhone && <span className="member-notify-hint">{t('settings.memberNotifications.noPhone')}</span>}
      {noEmail && <span className="member-notify-hint">{t('settings.memberNotifications.noEmail')}</span>}
    </span>
  );
}
